import { useContext } from 'react';
import { ACTIONS } from '../../../../../constants';
import { getActionService } from '../../../../../utils/getActionService';
import { AppContext } from '../../../../context';
import { ReportItem } from '../MenuItem';
import { DownloadReportsModel, EmployeeNodeModel } from '../../../../../models';
import { toast } from 'react-toastify';
import { getEmployeesIds } from '../../../../../utils';
import { handleDownloadReport } from '../../../../../utils/handleDownloadReport';

interface Props {
    startDateScheduling: string;
    selectedEmployees: EmployeeNodeModel[];
    endDateScheduling: string;
}

export const RequestMenuGroup: React.FC<Props> = ({
    endDateScheduling,
    selectedEmployees,
    startDateScheduling,
}) => {
    const { langResources, downloadReport, userInfo } = useContext(AppContext);

    /**
     * Descarga el reporte de Historial de Solicitudes por Autorizador
     */
    const handlerSaveReportRequestHistoryReport = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Historial de solicitudes por Autorizador',
            '/jerusalem/api/v2.0.0/reports/get-requests-history-by-authorizer',
            downloadReport
        );
    };

    /**
     * Descarga el reporte de Consolidado Cantidad de Personas por Turno
     */
    const handlerSaveCoverageReport = () => {
        handleDownloadReport(
            startDateScheduling,
            endDateScheduling,
            getEmployeesIds(selectedEmployees),
            langResources['reports.message.alert'],
            'Reporte de cubrimientos',
            '/jerusalem/api/v2.0.0/reports/get-workshift-scheduling-cover-requests',
            downloadReport
        );
    };

    const reportItems = [
        {
            label: 'Historial de solicitudes por Autorizador',
            handler: handlerSaveReportRequestHistoryReport,
            action: ACTIONS['reports']['RequestHistoryReport'],
            actionKey: 'RequestHistoryReport',
        },
        {
            label: 'Reporte de Cubrimientos',
            handler: handlerSaveCoverageReport,
            action: null,
            actionKey: 'CoverageReport',
        },
    ];

    return (
        <li className='nav-item px-4'>
            <a
                className='nav-link text-dark d-flex align-items-center justify-content-between'
                data-bs-toggle='collapse'
                href='#'
            >
                <span>Solicitudes</span>
                <i className='ri-arrow-drop-right-line fs-5'></i>
            </a>

            <div id='sidebarEcommerce' className='menu-dropdown collapse p-1'>
                <ul className='nav nav-sm flex-column px-3'>
                    {reportItems.map(
                        ({ label, handler, action, actionKey }) =>
                            (!action ||
                                getActionService(userInfo.actions, action)) && (
                                <ReportItem
                                    key={actionKey}
                                    label={label}
                                    handler={handler}
                                />
                            )
                    )}
                </ul>
            </div>
        </li>
    );
};
